import React from 'react';
import { AlertMessage } from './AlertMessage';

interface AlertProps {
  variant?: 'default' | 'destructive';
  children: React.ReactNode;
}

interface AlertDescriptionProps {
  children: React.ReactNode;
}

// AlertDescription을 먼저 정의
export const AlertDescription: React.FC<AlertDescriptionProps> = ({ children }) => {
  return <>{children}</>;
};

AlertDescription.displayName = 'AlertDescription';

export const Alert: React.FC<AlertProps> = ({ variant = 'default', children }) => {
  const type = variant === 'destructive' ? 'error' : 'info';
  
  // children에서 AlertDescription의 텍스트 추출
  let message = '';
  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      // AlertDescription 컴포넌트인 경우
      if (child.type === AlertDescription) {
        const childContent = child.props.children;
        if (typeof childContent === 'string') {
          message = childContent;
        } else if (React.isValidElement(childContent)) {
          const props = childContent.props as { children?: string };
          if (typeof props?.children === 'string') {
            message = props.children;
          }
        }
      } else {
        const props = child.props as { children?: string };
        if (typeof props?.children === 'string') {
          message = props.children;
        }
      }
    } else if (typeof child === 'string') {
      message = child;
    }
  });
  
  return <AlertMessage type={type} message={message || ''} />;
};

